
import {defineComponent, h, KeepAlive, onMounted, Transition} from 'vue';

export default defineComponent({
  name: 'oxd-tab-container',
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    showTabs: {
      type: Boolean,
      default: true,
    },
    animation: {
      type: Boolean,
      default: true,
    },
    keepAlive: {
      type: Boolean,
      default: false,
    },
    cacheAge: {
      type: Number,
      default: 10,
    },
  },
  emits: ['update:modelValue', 'clickTab'],
  setup(props, context) {
    let content = [];

    onMounted(() => {
      if (location.hash) {
        const hash = location.hash.replace(/^#/, '');
        const selectedTab = content.find(
          tab => hash === tab.props.name.replace(/\s+/g, '-').toLowerCase(),
        );
        if (selectedTab) {
          context.emit('update:modelValue', selectedTab.props.name);
        }
      }
    });

    return () => {
      content = context.slots.default?.();

      const generatePanels = (isKeepAlive: boolean) => {
        const activeTab = content.find((tab, index) => {
          if (!props.modelValue && index === 0) return true;
          return tab.props.name === props.modelValue;
        });
        return isKeepAlive
          ? h(KeepAlive, {age: props.cacheAge}, activeTab)
          : activeTab;
      };

      return h('div', {class: 'oxd-tab'}, [
        ...(props.showTabs
          ? [
              h(
                'div',
                {class: 'oxd-tab-bar'},
                content.map((tab, index) =>
                  h(
                    'a',
                    {
                      class: {
                        'oxd-tab-segment': true,
                        'oxd-tab-segment--active':
                          props.modelValue === tab.props.name ||
                          (props.modelValue === null && index === 0),
                        'oxd-tab-segment--disabled': tab.props?.disabled,
                      },
                      href: `#${tab.props.name
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`,
                      onClick: ($e: MouseEvent) => {
                        if (tab.props?.disabled) {
                          $e.preventDefault();
                        } else {
                          context.emit('clickTab', $e, tab.props.name);
                          context.emit('update:modelValue', tab.props.name);
                        }
                      },
                    },
                    tab.props.name || index,
                  ),
                ),
              ),
            ]
          : []),
        ...(props.animation
          ? [
              h(
                Transition,
                {
                  name: 'transition-slide-right',
                },
                {
                  default: () => generatePanels(props.keepAlive),
                },
              ),
            ]
          : [generatePanels(props.keepAlive)]),
      ]);
    };
  },
});
